import { Component, Input } from '@angular/core';

import { PlatformService } from 'src/app/services/platform.service';

import { theme } from '../../../../../../environments/theme';
import { getThemeConfig } from '../../../../config';

@Component({
    selector: 'custom-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})

export class HeaderComponent {

    @Input() showRegistrationLink: boolean = true;

    /**
     * userLang
     *
     * @type {string}
     */
    @Input() userLang;

    public themeName = theme.name;

     /**
     * theme configuration, based on domain
     */
     public themeConfig = getThemeConfig();

    constructor(
        public plt: PlatformService
    ) {
    }
}
